import React, { useState, useEffect } from 'react';
import { 
  getTeacherSubjects, 
  getTeacherDisplayName, 
  getTeacherTitle, 
  getTeacherInitials 
} from './TeacherDirectoryHelpers';

export const SubjectTeachersView = ({ teachers, loading, onTeacherSelect }) => {
  const [selectedSubject, setSelectedSubject] = useState(null);

  if (loading) {
    return (
      <div className="subject-teachers-view">
        <div className="loading">Loading teachers...</div>
      </div>
    );
  }

  // Group teachers by subject using helper function
  const teachersBySubject = teachers.reduce((acc, teacher) => {
    const subjects = getTeacherSubjects(teacher);
    if (subjects && subjects.length > 0) {
      subjects.forEach(subject => {
        if (!acc[subject]) {
          acc[subject] = [];
        }
        acc[subject].push(teacher);
      });
    }
    return acc;
  }, {});

  const subjects = Object.keys(teachersBySubject).sort();

  return (
    <div className="subject-teachers-view">
      <div className="view-header">
        <h2>按科目查看教師</h2>
      </div>

      <div className="subjects-overview">
        <h3>科目概覽</h3>
        {subjects.length > 0 ? (
          <div className="subjects-grid">
            {subjects.map(subject => (
              <div
                key={subject}
                className={`subject-card ${selectedSubject === subject ? 'selected' : ''}`}
                onClick={() => setSelectedSubject(selectedSubject === subject ? null : subject)}
              >
                <h4>{subject}</h4>
                <p className="teacher-count">{teachersBySubject[subject].length} 位教師</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-subjects">
            <p>目前沒有可用的科目資料</p>
          </div>
        )}
      </div>

      {selectedSubject && (
        <div className="subject-detail">
          <h3>{selectedSubject} - 教師列表</h3>
          <div className="teachers-list">
            {teachersBySubject[selectedSubject].map(teacher => (
              <div
                key={teacher.id}
                className="teacher-item"
                onClick={() => onTeacherSelect(teacher)}
              >
                <div className="teacher-avatar">
                  {teacher.avatar ? (
                    <img src={teacher.avatar} alt={getTeacherDisplayName(teacher)} />
                  ) : (
                    <div className="avatar-placeholder">
                      {getTeacherInitials(teacher)}
                    </div>
                  )}
                </div>
                <div className="teacher-info">
                  <h4 className="teacher-name">{getTeacherDisplayName(teacher)}</h4>
                  <p className="teacher-department">{teacher.department}</p>
                  <p className="teacher-title">{getTeacherTitle(teacher)}</p>
                  <p className="teacher-email">{teacher.email}</p>
                </div>
                <div className="teacher-status">
                  <span className={`status-indicator ${teacher.status === 'active' ? 'active' : 'inactive'}`}>
                    {teacher.status === 'active' ? '在職' : '離職'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!selectedSubject && (
        <div className="select-subject-prompt">
          <p>請選擇一個科目以查看相關教師</p>
        </div>
      )}
    </div>
  );
};
